import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RevisionContextHttpClient } from '@ispm-client/modules/core/services/revision-context-http-client';

@Injectable()
export class ManualCurationService {
    private static endpoint = 'manualcuration';

    constructor(private http:  RevisionContextHttpClient) {
    }

    public addToManualCuration(workflowRequestId: string, revisionId: string, command: string, ...aberrationIDs: string[]): Observable<any> {
        return this.http.post(ManualCurationService.endpoint, {
            workflowRequestId,
            revisionId,
            aberrationIDs,
            command,
        }, true);
    }
}
